const VERSION = "14.0.0";
export {
  VERSION
};
